import FormRepository from "@/repositories/FormRepository";

const repositories = {
    'FormRepository': FormRepository
}

export default {
    get: name => repositories[name]
};